import { ReactNode } from 'react';
import { Body1, Subtitle2, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalM,
    textAlign: 'center',
    paddingTop: tokens.spacingVerticalXXXL,
    paddingBottom: tokens.spacingVerticalXXXL,
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
  },
  icon: {
    fontSize: '32px',
    color: tokens.colorNeutralForeground3,
  },
  message: {
    color: tokens.colorNeutralForeground3,
    maxWidth: '420px',
  },
});

type TProps = {
  icon?: ReactNode;
  title: string;
  message?: string;
  action?: ReactNode;
};

// Fluent-style empty state with an optional clear action.
export const EmptyState = ({ icon, title, message, action }: TProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {icon ? <div className={classes.icon}>{icon}</div> : null}
      <Subtitle2>{title}</Subtitle2>
      {message ? (
        <Body1 as="p" className={classes.message}>
          {message}
        </Body1>
      ) : null}
      {action}
    </div>
  );
};
